module.exports = __webpack_public_path__ + "static/media/history_22.3b03ea6a.jpg";